import { combineReducers } from 'redux';
import immigrant from './immigrant';

export default combineReducers({ immigrant });
